// extracted by mini-css-extract-plugin
export default {"labelBox":"labelbox_labelBox__z0xsa","bottomBox":"labelbox_bottomBox__SDboQ","editBtn":"labelbox_editBtn__n5F4D"};